import { Injectable } from '@angular/core';
import { BcPrivilegesFacade } from '@bayclubs/employee-auth';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class OfficeSecurityService {
    constructor(private privilegesFacade: BcPrivilegesFacade) { }

    public get privilegesChanged$() {
        return this.privilegesFacade.privileges$;
    }

    public get canUseCourtBooking(): Observable<boolean> {
        return this.privilegesFacade.hasPrivilege('CourtBooking.canUseCourtBooking', null);
    }

    public get canUseCourtBookingSnapshot(): boolean {
        return this.privilegesFacade.hasPrivilegeSnapshot('CourtBooking.canUseCourtBooking', null);
    }

    public get canViewCourts(): Observable<boolean> {
        return this.privilegesFacade.hasPrivilege('CourtBooking.canViewCourts', null);
    }

    public get canViewCourtsSnapshot(): boolean {
        return this.privilegesFacade.hasPrivilegeSnapshot('CourtBooking.canViewCourts', null);
    }

    public get canManageCourts(): Observable<boolean> {
        return this.privilegesFacade.hasPrivilege('CourtBooking.canManageCourts', null);
    }

    public get canManageCourtsSnapshot(): boolean {
        return this.privilegesFacade.hasPrivilegeSnapshot('CourtBooking.canManageCourts', null);
    }

    public get canViewRulesMatrix(): Observable<boolean> {
        return this.privilegesFacade.hasPrivilege('CourtBooking.canViewRulesMatrix', null);
    }

    public get canViewRulesMatrixSnapshot(): boolean {
        return this.privilegesFacade.hasPrivilegeSnapshot('CourtBooking.canViewRulesMatrix', null);
    }

    public get canManageClubs(): Observable<boolean> {
        return this.privilegesFacade.hasPrivilege('CourtBooking.canManageClubs', null);
    }

    public get canViewReports(): boolean {
        return this.privilegesFacade.hasPrivilegeSnapshot('CourtBooking.canViewReports', null);
    }
}
